// @ts-nocheck
import React from "react";
import DelayLink from "/components/core/DelayLink";
import FunticoLogo from "/components/core/Logo";
import Socials from "/components/core/Socials";
import Steam from "/assets/img/steam.svg";
import { useTranslation } from "/utils/hooks/useCustomTranslation";
import { useAnimation } from "/context/AnimationProvider";
import { funticoUrl, aboutUrl, summonersUrl, gameloopUrl } from "/utils/links";

export default function Footer() {
  const { t } = useTranslation();
  const date = new Date().getFullYear();
  const { isMobile } = useAnimation();

  const gen = [
    {
      to: `${funticoUrl}/`,
      title: "Funtico (Home)",
    },
    { to: `${gameloopUrl}/`, title: "GameLoop" },
  ];
  const sec = [
    { to: `${aboutUrl}/`, title: "About Us" },
    {
      to: "https://litepaper.funtico.com/funtico-litepaper",
      title: "Litepaper",
    },
  ];
  const pr = [
    {
      to: `${funticoUrl}/contact`,
      title: t("layout.menus.contact"),
    },
    {
      to: `${funticoUrl}/terms-and-conditions`,
      title: t("layout.menus.terms"),
    },
    {
      to: `${funticoUrl}/privacy-policy`,
      title: t("layout.menus.privacy"),
    },
  ];

  const mobileLinks = [
    [
      { to: `${funticoUrl}/`, title: "Home" },
      {
        to: `${funticoUrl}/compete-2-win`,
        title: "Compete-2-Win",
      },
      { to: `${funticoUrl}/backpack`, title: "My Backpack" },
      { to: `${funticoUrl}/marketplace`, title: "Marketplace" },
      { to: `${funticoUrl}/loot-packs`, title: "Loot Packs" },
      { to: `${funticoUrl}/wheel-of-fortune`, title: "Wheel Of Fortune" },
    ],
    [
      { to: `${aboutUrl}/`, title: "About us" },
      {
        to: `${summonersUrl}/?_gl=1*1cfhptu*_gcl_au*MTQ2Mjc1NTYyNC4xNzUyOTM5MTI0`,
        title: "Summoners NFT",
      },
      {
        to: "https://litepaper.funtico.com/funtico-litepaper?_gl=1*9pq9y8*_gcl_au*MTQ2Mjc1NTYyNC4xNzUyOTM5MTI0",
        title: "Check Litepaper",
      },
      {
        to: "https://www.youtube.com/channel/UCKNSppHiWRtKlqxyvAntNwQ",
        title: "Check Trailers",
      },
      {
        to: "https://store.steampowered.com/app/2774710/Heroes_of_the_Citadel/",
        title: "Wishlist Us Now",
        icon: () => <Steam />,
      },
    ],
  ];

  const scrollToTop = () => {
    if (window.scrollToSection) {
      window.scrollToSection(0);
    } else {
      gsap.to(window, {
        scrollTo: {
          y: 0,
        },
        duration: 0.5,
      });
    }
  };

  return (
    <>
      <footer className="footer">
        <div className="section_content df fd-c pd-lr-md">
          <div className="footer_top df">
            <div className="footer_left">
              <div className="fantico_logo select-logo" onClick={scrollToTop}>
                <img src="/logo-sports.png" alt="" />
              </div>

              <p className="subtitle mr-t-16 op">
                {t("layout.menus.subtitle")}
              </p>

              <p className="fixel_16_md footer_copy">
                ©{date} Funtico, Minthauz Inc.
              </p>
            </div>
            <div className="footer_center col df">
              <div className="pages df ai-st fd-c gen">
                {gen.map((l) => (
                  <DelayLink key={l.to} {...l} className="l fixel_16_sbl op">
                    {t(l.title)}
                  </DelayLink>
                ))}
              </div>
              <div className="pages df ai-st fd-c sec">
                {sec.map(({ icon, ...l }, i) => (
                  <DelayLink {...l} className="l fixel_16_sbl op" key={i}>
                    {icon && <div className="icon-24">{icon()}</div>}
                    {t(l.title)}
                  </DelayLink>
                ))}
              </div>
            </div>
            <div className="footer_right col df ai-st jc-sb">
              <div className="pages df ai-st fd-c pr">
                {pr.map((l) => (
                  <DelayLink key={l.to} {...l} className="l fixel_16_sbl op">
                    {t(l.title)}
                  </DelayLink>
                ))}
              </div>
              <Socials />
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
